import React, { Component } from 'react';
import { connect } from 'react-redux';
import Spinning from '@zacousticrepo/grommet-v1-custom/components/icons/Spinning';
import Box from '@zacousticrepo/grommet-v1-custom/components/Box';
import Notification from '@zacousticrepo/grommet-v1-custom/components/Notification';
import CustomerFacingSurveyControl from '../../../../components/CustomerFacingSurveyControl';
import { fetchCustomerFacingSurvey, setAccessKey, unloadCustomerFacingSurvey } from './CustomerFacingSurveyActions';

class CustomerFacingSurvey extends Component {
    constructor(props) {
        super(props);
        const key = props.location.query['key'];
        this.props.dispatch(setAccessKey(key));
        this.props.dispatch(fetchCustomerFacingSurvey(key));
    }

    componentWillUnmount() {
        this.props.dispatch(unloadCustomerFacingSurvey());
    }

    render() {
        const { survey, surveyForms, customerLink, error } = this.props;

        const logo =
            customerLink && customerLink.LogoLink ? (
                <div>
                    <img src={customerLink.LogoLink} />
                </div>
            ) : (
                undefined
            );

        if (error) {
            if (error.bodyContent && error.bodyContent.Message === 'The access key is expired or not found') {
                return (
                    <Box
                        direction="column"
                        responsive={true}
                        pad={{ between: 'small', horizontal: 'medium', vertical: 'medium' }}>
                        {logo}
                        <Box
                            style={{
                                border: '3px solid #37AB63',
                                borderRadius: 30,
                                padding: 20,
                                textAlign: 'center',
                                lineHeight: '2em'
                            }}>
                            Thank you for your interest.<br /> The survey has expired.
                        </Box>
                    </Box>
                );
            }
            return (
                <Box>
                    {logo}
                    <Notification
                        status="critical"
                        size="large"
                        state={error.message}
                        message="An unexpected error happened, please try again later"
                    />
                    <Box>{error}</Box>
                </Box>
            );
        }

        if (survey === undefined || surveyForms === undefined || surveyForms === null || surveyForms.length === 0) {
            return (
                <Box
                    direction="column"
                    responsive={true}
                    pad={{ between: 'small', horizontal: 'medium', vertical: 'medium' }}>
                    {logo}
                    <Spinning />
                    <span>Loading...</span>
                </Box>
            );
        }

        if (survey != null && survey.IsSubmitted) {
            return (
                <Box
                    responsive={false}
                    flex={false}
                    style={{ display: 'block' }}
                    pad={{ between: 'medium', horizontal: 'medium', vertical: 'medium' }}>
                    {logo}
                    <p />
                    <Box
                        responsive={false}
                        flex={false}
                        style={{
                            display: 'block',
                            border: '3px solid #37AB63',
                            borderRadius: 30,
                            padding: 20,
                            textAlign: 'center'
                        }}>
                        <span>Thank you for your feedback!</span>
                    </Box>
                    <p />
                </Box>
            );
        }

        const surveyForm = surveyForms.find(o => o.Id === survey.SurveyFormId);
        if (surveyForm.SurveyQuestions.length < 1) {
            return (
                <Box
                    direction="column"
                    responsive={true}
                    pad={{ between: 'small', horizontal: 'medium', vertical: 'medium' }}>
                    {logo}
                    <span>Survey contains no question.</span>
                </Box>
            );
        }

        return (
            <div id="customerFacingSurveyControl" style={{ marginTop: '20px' }}>
                <CustomerFacingSurveyControl />
            </div>
        );
    }
}

const select = state => ({ ...state.customerFacingSurvey });
export default connect(select)(CustomerFacingSurvey);
